export const CONTENT_TYPE_HEADER = 'Content-Type';

export const CONTENT_TYPES = {
    JSON: 'application/json',
    PDF: 'application/pdf',
};
